(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/init.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.app.start();
})(Backbone, _, svs);
 })(window);